import { FC, HTMLAttributes } from "react";

import { LinkProps, Link } from "./Link";

import "./PrimaryLink.css";

interface ButtonProps extends HTMLAttributes<HTMLButtonElement> { }

export const PrimaryLink: FC<LinkProps> = props => (
  <Link {...props} className={`primary-link ${props.className || ""}`} />
)

export const PrimaryButton: FC<ButtonProps> = props => (
  <button {...props} className={`primary-link ${props.className || ""}`} />
)